var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 35.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,32.5V43a2,2,0,0,1-2,2H7a2,2,0,0,1-2-2V32.5a3,3,0,0,1,1.7-2.8h.1l7.4-3.4a2.8,2.8,0,0,1,1.3-.3v5.3a4.6,4.6,0,0,0-3,4.2,4.5,4.5,0,0,0,9,0,4.6,4.6,0,0,0-3-4.2V27l.5.3a9.9,9.9,0,0,0,10,0l.5-.3v3.7A6,6,0,0,0,25,36.5V39a2.5,2.5,0,0,0,2.5,2.5h1a1.5,1.5,0,0,0,0-3H28v-2a3,3,0,0,1,6,0v2h-.5a1.5,1.5,0,0,0,0,3h1A2.5,2.5,0,0,0,37,39V36.5a6,6,0,0,0-4.5-5.8V26a2.8,2.8,0,0,1,1.3.3l7.5,3.4A3,3,0,0,1,43,32.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 14,
    r: 11
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDoctor);
export default __webpack_public_path__ + "static/media/user-doctor.810db63851109db374263d4bdce89754.svg";
export { ForwardRef as ReactComponent };